import type { TechFormSubmissionDraft } from "../models/tech-form-submission-data.models";

function hasLocalTechFormSectionData(sectionName: keyof TechFormSubmissionDraft, value: unknown): boolean {
  if (Array.isArray(value)) return value.length > 0;
  if (value === null || typeof value !== "object") return false;

  const localSectionKeys = Object.keys(value);
  return sectionName === "tq1VesselDetails"
    ? localSectionKeys.some((key) => key !== "techFormSchemaVersion")
    : localSectionKeys.length > 0;
}

export function mergeTechFormSubmissionDraft(
  localDraft: TechFormSubmissionDraft,
  persistedDraft: TechFormSubmissionDraft,
): TechFormSubmissionDraft {
  const mergedDraft = Object.fromEntries(
    Object.entries(persistedDraft).map(([sectionName, persistedValue]) => {
      const techFormSectionName = sectionName as keyof TechFormSubmissionDraft;
      const localValue = localDraft[techFormSectionName];
      return [sectionName, hasLocalTechFormSectionData(techFormSectionName, localValue) ? localValue : persistedValue];
    }),
  ) as unknown as TechFormSubmissionDraft;

  return {
    ...mergedDraft,
    tq1VesselDetails: {
      ...mergedDraft.tq1VesselDetails,
      techFormSchemaVersion: persistedDraft.tq1VesselDetails.techFormSchemaVersion,
    },
  };
}
